import type { ComponentType } from 'react'
import type { DentalIconProps } from '../components/icons/DentalIcons'
import {
  CompassExploreIcon,
  DentalImplantIcon,
  SmileSparkleIcon,
  ToothBracesIcon,
  ToothPainIcon,
  ToothSparkleIcon,
} from '../components/icons/DentalIcons'

export type Need = {
  id: string
  icon: ComponentType<DentalIconProps>
  title: string
  description: string
  message: string
  variant?: 'dashed'
}

export const needs: Need[] = [
  {
    id: 'dolor',
    icon: ToothPainIcon,
    title: 'Me duele algo',
    description: 'Dolor, sensibilidad o molestia',
    message: 'Hola, tengo un dolor dental y necesito orientación. ¿Pueden ayudarme?',
  },
  {
    id: 'limpieza',
    icon: ToothSparkleIcon,
    title: 'Quiero una limpieza',
    description: 'Prevención y cuidado rutinario',
    message: 'Hola, quisiera agendar una limpieza dental. ¿Cuál es la disponibilidad?',
  },
  {
    id: 'estetica',
    icon: SmileSparkleIcon,
    title: 'Quiero mejorar mi sonrisa',
    description: 'Estética y diseño dental',
    message: 'Hola, me interesa mejorar la estética de mi sonrisa. ¿Tienen valoraciones para eso?',
  },
  {
    id: 'ortodoncia',
    icon: ToothBracesIcon,
    title: 'Busco ortodoncia',
    description: 'Alineación y corrección dental',
    message: 'Hola, estoy buscando opciones de ortodoncia. ¿Podrían darme información?',
  },
  {
    id: 'implantes',
    icon: DentalImplantIcon,
    title: 'Perdí un diente',
    description: 'Implantes y rehabilitación',
    message: 'Hola, perdí un diente y quiero conocer opciones de implantes.',
  },
  {
    id: 'orientacion',
    icon: CompassExploreIcon,
    title: 'No sé por dónde empezar',
    description: 'Valoración inicial completa',
    message:
      'Hola, hace tiempo no voy al odontólogo y quiero retomar mi cuidado dental. ¿Por dónde debo empezar?',
    variant: 'dashed',
  },
]
